import { dataGet } from '../../dot'
import required from './required'

/**
 * Rule to check if the field contains a value when another field has a certain value
 * 
 * Usage: required_if:another_field,another_value
 * 
 */
export default {
    name     : 'required_if',
    validate : (value, data, parameters) => {
        if(dataGet(parameters[0], data) == parameters[1]){
            return required.validate(value)
        }

        return true
    },
    message: (field, data, parameters) => `The field ${field} is required when ${parameters[0]} is ${parameters[1]}`
}